import React from 'react';
import { useSelector } from 'react-redux';
import { List } from 'semantic-ui-react';

import diseaseActivitiesSelectors from 'diseaseActivitiesInLocation/diseaseActivitiesInLocation.selectors';
import diseaseActivityPanelsSelectors from 'diseaseActivityPanels/diseaseActivityPanels.selectors';

import DiseaseInLocationCard from './DiseaseInLocationCard';

const DiseasesList: React.FC = () => {
  const locationId = useSelector(diseaseActivityPanelsSelectors.getSelectedLocationId);
  const diseaseIds = useSelector(diseaseActivitiesSelectors.getFilteredDiseaseIds);
  return (
    <List>
      {locationId &&
        diseaseIds.map(diseaseId => (
          <DiseaseInLocationCard diseaseId={diseaseId} key={diseaseId} />
        ))}
    </List>
  );
};
export default DiseasesList;
